import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import useAddMetersTable from "./useAddMetersTable.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { memberships } from "variables/markets";
import { postMarketMeters, getMarketMemberships } from "services/ConfigServices";
import { MarketsContext } from "context/MarketsContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import DataTable from "react-data-table-component";
import LinearProgress from "@mui/material/LinearProgress";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "64.5ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "64.5ch",
  },
}));

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


function AddMetersDialog(props) {
  const { closeModal, refetch, marketmeters } = props;
  const appContext = useContext(MarketsContext);
  const { market } = appContext;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;

  const [membershipsOptions, setMembershipsOptions] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [membership, setMembership] = useState({});
  const [membershipGroup, setMembershipGroup] = useState("");

  const [selected, setSelected] = useState([]);

  const { gridState } = useAddMetersTable(membershipGroup, marketmeters);

  const handleMembershipChange = (newValue) => {
    setMembership(newValue);
    if (newValue) {
      let obj = memberships.find((o) => o.id === newValue.id);
      setMembershipGroup(obj?.parameters.groups[0]);
    }
    else {
      setMembershipGroup("");
    }
  };

  const selectedMembership = () => {
    let selected = {};
    if (membership !== undefined) {
      selected = membership;
    }
    return selected;
  };

  const [buttonDisabled, setButtonDisabled] = useState(true);
  useEffect(() => {
    if (selected.length > 0) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [selected]);

  const columns = [
    {
      name: "Numéro de compteur",
      selector: (row) => row.meternumber,
      sortable: true,
      maxWidth: "9rem",
    },
    {
      name: "Segment",
      selector: (row) => row.details.segment,
      sortable: true,
      omit: market.parameters?.general?.energy !== 'electricity',
      maxWidth: "8rem",
    },
    {
      name: "Profil",
      selector: (row) => row.details.profil,
      sortable: true,
      omit: market.parameters?.general?.energy !== 'gas',
      maxWidth: "8rem",
    },
    {
      name: "Acheminement",
      selector: (row) => row.details.acheminement,
      sortable: true,
      maxWidth: "10rem",
    },
  ];

  useEffect(() => {
    axios
      .get(
        getMarketMemberships(chartIdGroup, market.id),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpMembershipsData = res.data.memberships?.map((data) => {
          return (
            { name: data.parameters.name + ' (' + data.parameters.marketmembershipnumber + ')', id: data.id }
          );
        });
        setMembershipsOptions(tmpMembershipsData || []);
        setMemberships(res.data.memberships || []);
      });

  }, []);

  const handleSubmit = async (event) => {
    addMarketMeters(event);
  };


  const addMarketMeters = async (event) => {
    await axios
      .post(
        postMarketMeters(membership.id),
        {
          meters:selected
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Compteurs ajoutés");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    console.log(selection);
    const newSelected = selection.selectedRows.map((row) => {
      return (
        { parameters: { meternumber: row.meternumber, status: 'in', datebegin: moment().format("YYYY-MM-DD") }, accountmeterid: row.id })
    });
    setSelected(newSelected);
    console.log(newSelected);
    //setResIds(newSelected);
  };


  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <AutocompleteInputMeters
                specialWidth={"97%"}
                inputTitle={"Choix de l'adhérent"}
                selected={selectedMembership()}
                list={membershipsOptions}
                handleChange={(_, newValue) =>
                  handleMembershipChange(newValue)
                }
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
              noDataComponent={<NoData>Aucun compteur à afficher</NoData>}
              noHeader={true}
              columns={columns}
              persistTableHead
              pagination
              subHeader
              dense={true}
              onSelectedRowsChange={handleSelectedRowsChange}
              selectableRows={true}
              progressPending={gridState.loading}
              progressComponent={<LinearProgress />}
              expandableRowDisabled={(row) => row.disabled}
              paginationComponentOptions={{
                noRowsPerPage: false,
                rowsPerPageText: "Lignes par page",
                rangeSeparatorText: "sur",
                selectAllRowsItem: false,
                selectAllRowsItemText: "Selectionner toutes les lignes",
              }}
              {...gridState}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Ajouter
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default AddMetersDialog;
